import { Progress } from "../../shadcn/components/ui/progress";
import { DateTime } from "luxon";
interface ProgressProps {
  startTime: number;
  endTime: number;
  currentTime: any;
}

const TimerProgressBar: React.FC<ProgressProps> = ({
  startTime,
  endTime,
  currentTime,
}) => {
  const calculateProgress = (): number => {
    const serverTime = DateTime.fromFormat(
      String(currentTime),
      "d MMMM yyyy hh:mm:ss a",
      {
        zone: "Asia/Kolkata",
      }
    ).toMillis();
    if (startTime >= serverTime) return 0;
    if (serverTime >= endTime) return 100;

    const elapsed = serverTime - startTime;
    const totalDuration = endTime - startTime;
    return Math.min((elapsed / totalDuration) * 100, 100);
  };

  return (
    <div className="w-full ">
      <Progress
        value={calculateProgress()}
        className="h-[3px] w-full"
        fillColor="bg-[#5D5FEF]"
      />
    </div>
  );
};

export default TimerProgressBar;
